export const ORDER_STATUS_CODES_NEW = {
  NEW: 0,
  ACCEPTED: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
  CLAIM: 4,
  CANCELLED: 5,
  WASTED_VISIT: 6,
};
